
































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import loader from "@/components/loader.vue";

import { momentTZ as moment } from "@/helpers/moment";
import dataApi from "@/services/history";
import { Getter, Action, Mutation } from "vuex-class";
import accountsApi from "@/services/accounts";
import { setInterval } from "timers";
import dialogs from "@/dialogs/index.vue";
import  { clearCache } from '@/helpers/cache';

import { NSLog } from "@/helpers/log";
const log = NSLog("/App");

import { format as formatError } from "@/helpers/errors";

import AdvancedMenu from "@/components/AdvancedMenu.vue";

@Component({
  components: {
    loader,
    dialogs,
    AdvancedMenu,
  },
})
export default class App extends Vue {
  get loading() {
    return this.rootState || this.authState || this.navState || this.msg;
  }
  get loadingMsg() {
    return this.authState || this.navState || this.rootState || this.msg; // note priority of state to display
  }

  get showToolbar() {
    return !this.loading && this.$route.meta.hideToolbar !== true;
  }

  get showBreakpointText() {
    return process.env.NODE_ENV === "development";
  }

  private get errFormat() {
    return formatError(this.lastErr);
  }

  @Getter('auth/initials') public initials!: string;

  @Mutation("setLastErr") public setLastErr: any;

  @Action("nav/gotoView") public gotoView: any;

  @Mutation("setSnackbarState") public setSnackbarState: any;
  @Getter("snackbarState") public snackbarState?: boolean;
  @Getter("snackbarText") public snackbarText?: string;
  private drawer = true;

  private msg = "Loading Portal";

  // store states to show in loader
  @Getter("state") private rootState: any;
  @Getter("auth/state") private authState: any;
  @Getter("nav/state") private navState: any;

  @Getter("auth/permissionsFlat") private permissionsFlat: any;
  @Getter("auth/hasPermission") private hasPermission: any;

  @Getter("globalSelectedAccount") private globalSelectedAccount: any;
  @Getter("globalSelectedAccountDisplayText")
  private globalSelectedAccountDisplayText: any;

  // timezone
  @Getter("tzName") private tzName: any;

  // last error
  @Getter("lastErr") private lastErr: any;

  @Action("reload") private reload: any;
  @Action("setSelectedAccount") private setSelectedAccount: any;
  @Action("nav/showDialog") private showDialog: any;
  @Action("auth/logout") private logout: any;

  private created() {
    const w: any = window;
    w.document.title = process.env.VUE_APP_TITLE;
  }

  private home() {
    this.$router.push("/");
  }

  private async mounted() {
    // init application
    try {
      await this.$store.dispatch("init");
    } catch (err) {
      if (err !== "need_login") {
        log("init err:", err);
        if (err.message) {
          // alert(err.message);
          this.setLastErr(err.msg);
        } else {
          // alert(err);
          this.setLastErr(err);
        }
      }
    }
    this.msg = "";
  }
  private resetSelecteNewAccount() {
    // this.setSelectedAccount(null);
    // this.$router.push("/pivot/all orders");
    this.gotoView("default");
  }
  get ccDate() {
    return new Date().getFullYear();
  }

  async refreshAll() {
    await clearCache();
    this.reload();
  }
}
